var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_1445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8125 10.3125H8.53463L11.3685 7.48C11.6366 7.21188 11.6366 6.77872 11.3685 6.50372C11.0997 6.2356 10.6645 6.2356 10.3957 6.50372L6.50649 10.395C6.34218 10.56 6.29062 10.7869 6.32843 11C6.29062 11.2131 6.34218 11.44 6.50649 11.605L10.3957 15.4963C10.6645 15.7644 11.0997 15.7644 11.3685 15.4963C11.6366 15.2282 11.6366 14.7881 11.3685 14.52L8.53463 11.6875H15.8125C16.192 11.6875 16.5 11.3781 16.5 11C16.5 10.6219 16.192 10.3125 15.8125 10.3125ZM11 20.625C5.68425 20.625 1.375 16.3144 1.375 11C1.375 5.68563 5.68425 1.375 11 1.375C16.3158 1.375 20.625 5.68563 20.625 11C20.625 16.3144 16.3158 20.625 11 20.625ZM11 0C4.92525 0 0 4.9225 0 11C0 17.0775 4.92525 22 11 22C17.0748 22 22 17.0775 22 11C22 4.9225 17.0748 0 11 0Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_1445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.e5e2d6672e838eedb94c9e76bd360642.svg";
export { ForwardRef as ReactComponent };